import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5b25a02b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "optical-bank-page"
};
const _hoisted_2 = {
  class: "page-header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h1", null, "黑盒光路题库"), /*#__PURE__*/_createElementVNode("p", null, "使用 5×5 光路配置器维护题目。停用题目不会进入新的随机练习。")], -1));
const _hoisted_4 = {
  class: "panel group-panel"
};
const _hoisted_5 = {
  key: 0,
  class: "empty-groups"
};
const _hoisted_6 = {
  class: "group-actions"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "text-danger",
  type: "button"
}, "删除分组", -1));
const _hoisted_8 = {
  class: "panel question-panel"
};
const _hoisted_9 = {
  class: "question-toolbar"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  class: "card-heading"
};
const _hoisted_12 = {
  class: "number"
};
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = {
  class: "card-actions"
};
const _hoisted_15 = {
  class: "answer"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "text-danger",
  type: "button"
}, "删除", -1));
const _hoisted_18 = {
  key: 0,
  class: "config-preview"
};
const _hoisted_19 = {
  class: "preview-section"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "内部结构", -1));
const _hoisted_21 = {
  class: "preview-section"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "已知案例", -1));
const _hoisted_23 = {
  class: "board-preview-grid"
};
const _hoisted_24 = {
  class: "preview-section"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "新射入路径与选项", -1));
const _hoisted_26 = {
  class: "board-preview-grid"
};
const _hoisted_27 = {
  key: 1,
  class: "image-section"
};
const _hoisted_28 = {
  class: "image-column"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "section-label"
}, "旧版题目图片", -1));
const _hoisted_30 = {
  class: "image-column"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "section-label"
}, "旧版选项图片", -1));
const _hoisted_32 = {
  key: 2,
  class: "analysis"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "解析", -1));
const _hoisted_34 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_LeftGroupList = _resolveComponent("LeftGroupList");
  const _component_ButtonDialog = _resolveComponent("ButtonDialog");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_OpticalPathBoard = _resolveComponent("OpticalPathBoard");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_row = _resolveComponent("el-row");
  const _component_OpticalPathQuestionConfigurator = _resolveComponent("OpticalPathQuestionConfigurator");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_hoisted_3, $data.groupId ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    type: "primary",
    onClick: _cache[0] || (_cache[0] = $event => $options.openEditor())
  }, {
    default: _withCtx(() => [_createTextVNode("新增题目")]),
    _: 1
  })) : _createCommentVNode("", true)]), _createVNode(_component_el_row, {
    gutter: 16,
    class: "content-row"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      xs: 24,
      sm: 7,
      md: 5
    }, {
      default: _withCtx(() => [_createElementVNode("section", _hoisted_4, [_createVNode(_component_LeftGroupList, {
        "group-title": "题目分组",
        data: $data.groups,
        onChoose: $options.onChoose
      }, null, 8, ["data", "onChoose"]), $data.groups.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, "暂无分组")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createVNode(_component_ButtonDialog, {
        "btn-id": 35,
        "btn-name": "+ 新增分组",
        style: 1,
        size: "small",
        onFresh: $options.init
      }, null, 8, ["onFresh"]), $data.groupId ? (_openBlock(), _createBlock(_component_el_popconfirm, {
        key: 0,
        title: "该分组内题目会一起删除，确定继续吗？",
        onConfirm: $options.deleteGroup
      }, {
        reference: _withCtx(() => [_hoisted_7]),
        _: 1
      }, 8, ["onConfirm"])) : _createCommentVNode("", true)])])]),
      _: 1
    }), _createVNode(_component_el_col, {
      xs: 24,
      sm: 17,
      md: 19
    }, {
      default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("section", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString($options.currentGroupName || '请选择分组'), 1), $data.groupId ? (_openBlock(), _createElementBlock("span", _hoisted_10, "共 " + _toDisplayString($data.total) + " 题", 1)) : _createCommentVNode("", true)])]), !$data.loading && $data.groupId && $data.questions.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 0,
        description: "该分组还没有题目"
      })) : !$data.loading && !$data.groupId ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        description: "请先创建或选择题目分组"
      })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questions, (question, index) => {
        return _openBlock(), _createElementBlock("article", {
          key: question.id,
          class: "question-card"
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_12, _toDisplayString($data.page * $data.pageSize + index + 1), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(question.title), 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, "答案 " + _toDisplayString(question.rightAnswer), 1), _createVNode(_component_el_switch, {
          "model-value": question.enabled,
          "active-text": "启用",
          "inactive-text": "停用",
          onChange: enabled => $options.toggleEnabled(question, enabled)
        }, null, 8, ["model-value", "onChange"]), _createElementVNode("button", {
          class: "text-action",
          type: "button",
          onClick: $event => $options.openEditor(question)
        }, "编辑", 8, _hoisted_16), _createVNode(_component_el_popconfirm, {
          title: "确定删除此题吗？",
          onConfirm: $event => $options.deleteQuestion(question.id)
        }, {
          reference: _withCtx(() => [_hoisted_17]),
          _: 2
        }, 1032, ["onConfirm"])])]), question._opticalConfig ? (_openBlock(), _createElementBlock("details", _hoisted_18, [_createElementVNode("summary", null, [_createTextVNode(" 查看题目配置 "), _createElementVNode("span", null, _toDisplayString($options.elementCount(question._opticalConfig)) + " 个元件，" + _toDisplayString(question._opticalConfig.cases.length) + " 个已知案例", 1)]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createVNode(_component_OpticalPathBoard, {
          "model-value": question._opticalConfig.layout,
          compact: "",
          "show-arrow-slots": false,
          "aria-label": "内部结构预览"
        }, null, 8, ["model-value"])]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question._opticalConfig.cases, (knownCase, caseIndex) => {
          return _openBlock(), _createBlock(_component_OpticalPathBoard, {
            key: caseIndex,
            "model-value": knownCase,
            compact: "",
            "show-elements": false,
            "aria-label": `已知案例 ${caseIndex + 1}`
          }, null, 8, ["model-value", "aria-label"]);
        }), 128))])]), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [_createVNode(_component_OpticalPathBoard, {
          "model-value": question._opticalConfig.target,
          compact: "",
          "show-elements": false,
          "aria-label": "新射入路径"
        }, null, 8, ["model-value"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question._opticalConfig.options, (option, optionIndex) => {
          return _openBlock(), _createBlock(_component_OpticalPathBoard, {
            key: optionIndex,
            "model-value": option,
            compact: "",
            "show-elements": false,
            "aria-label": `选项 ${String.fromCharCode(65 + optionIndex)}`
          }, null, 8, ["model-value", "aria-label"]);
        }), 128))])])])) : (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_hoisted_29, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.parseImages(question.questionImages), image => {
          return _openBlock(), _createBlock(_component_el_image, {
            key: image,
            src: image,
            fit: "contain"
          }, null, 8, ["src"]);
        }), 128))]), _createElementVNode("div", _hoisted_30, [_hoisted_31, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.parseImages(question.optionImages), image => {
          return _openBlock(), _createBlock(_component_el_image, {
            key: image,
            src: image,
            fit: "contain"
          }, null, 8, ["src"]);
        }), 128))])])), question.analysisText || $options.parseImages(question.analysisImages).length ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_hoisted_33, question.analysisText ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(question.analysisText), 1)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.parseImages(question.analysisImages), image => {
          return _openBlock(), _createBlock(_component_el_image, {
            key: image,
            src: image,
            "preview-src-list": $options.parseImages(question.analysisImages),
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"]);
        }), 128))])) : _createCommentVNode("", true)]);
      }), 128)), $data.total > $data.pageSize ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 2,
        class: "pagination",
        background: "",
        layout: "prev, pager, next",
        "current-page": $data.page + 1,
        "page-size": $data.pageSize,
        total: $data.total,
        onCurrentChange: _cache[1] || (_cache[1] = value => {
          $data.page = value - 1;
          $options.fetchQuestions();
        })
      }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])), [[_directive_loading, $data.loading]])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_OpticalPathQuestionConfigurator, {
    visible: $data.editorVisible,
    "onUpdate:visible": _cache[2] || (_cache[2] = $event => $data.editorVisible = $event),
    question: $data.editingQuestion,
    "group-id": $data.groupId,
    onSaved: $options.fetchQuestions
  }, null, 8, ["visible", "question", "group-id", "onSaved"])]);
}